import "./AddCustomerWidget.scss";
import { Link } from "react-router-dom";
import Icon from "../../../assets/icons";
import { useState } from "react";
import secondaryComponents from "..";
import { UserDangerIcon, UserSuccessIcon } from "../../../assets/svgIcons";
import { pathConstants } from "../../../routes/pathContants";

const AddCustomerWidgetModal = ({ closeModal = () => {} }) => {
  const [isCreateMultipleCustomer, setIsCreateMultipleCustomer] =
    useState(false);
  return (
    <>
      <div className="add-product-widget">
        <Link
          className="add-product-widget__item"
          to={pathConstants.CUSTOMER_CREATE}
          onClick={() => closeModal()}
        >
          <div className="icon orange">
            <UserDangerIcon />
          </div>
          <div>
            <p className="font-weight-semibold dark--text">Single Customer</p>
            <p className="smallest-text-size">Create a new customer record</p>
          </div>
          <img className="ml-auto" src={Icon.chevron_right_arrow} alt="" />
        </Link>

        <Link
          className="add-product-widget__item"
          onClick={() => {
            setIsCreateMultipleCustomer(true);
          }}
        >
          <div className="icon green">
            <UserSuccessIcon />
          </div>
          <div>
            <p className="font-weight-semibold dark--text">
              Bulk Upload Customers
            </p>
            <p className="smallest-text-size">
              Migrate all your customers into Lumi Business with .CSV bulk
              upload
            </p>
          </div>
          <img className="ml-auto" src={Icon.chevron_right_arrow} alt="" />
        </Link>
      </div>

      {/* batch upload */}
      <secondaryComponents.Modal
        isActive={isCreateMultipleCustomer}
        closeModal={() => {
          setIsCreateMultipleCustomer(false);
        }}
        width={700}
      >
        <secondaryComponents.AddMultipleCustomers
          closeWidget={() => setIsCreateMultipleCustomer(false)}
        />
      </secondaryComponents.Modal>
    </>
  );
};

export default AddCustomerWidgetModal;
